module.exports = __webpack_public_path__ + "img/error.d9b88eee.svg";